
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infos-legales/conditions-generales",
      function () {
        return require("private-next-pages/infos-legales/conditions-generales.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infos-legales/conditions-generales"])
      });
    }
  